(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9029],{

/***/ 62609:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/blockquiry/viceandvirtueindex",
      function () {
        return __webpack_require__(96953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ viceandvirtueindex; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(78016);
// EXTERNAL MODULE: ./src/components/about/AboutLayout.js + 4 modules
var AboutLayout = __webpack_require__(93379);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Unstable_Grid2/Grid2.js + 2 modules
var Grid2 = __webpack_require__(95413);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(81401);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./src/tokens.js
var src_tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
;// CONCATENATED MODULE: ./src/components/about/viceandvirtue/AboutCryptoCvviGauge.js
/* eslint-disable no-unused-expressions */ /* eslint-disable no-template-curly-in-string */ /* eslint-disable no-unused-vars */ 







// const CVVIButton = styled(ButtonBase)(({ theme }) => ({
//   position: 'relative',
//   maxHeight: 600,
//   [theme.breakpoints.down('sm')]: {
//     width: '100% !important', // Overrides inline-style
//     maxHeight: 250,
//   },
//   '&:hover, &.Mui-focusVisible': {
//     zIndex: 99,
//     '& .MuiImageBackdrop-root': {
//       opacity: 0.15,
//       backgroundColor: tokens.token_apple_grey,
//     },
//     '& .MuiImageMarked-root': {
//       opacity: 0,
//     },
//     '& .MuiTypography-root': {
//       border: '4px solid currentColor',
//     },
//   },
// }));
// const CVVIBackdrop = styled('span')(({ theme }) => ({
//   position: 'absolute',
//   left: 0,
//   right: 0,
//   top: 0,
//   bottom: 0,
//   backgroundColor: tokens.token_surface,
//   opacity: 0,
//   transition: theme.transitions.create('opacity'),
// }));
var LogoMarked = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        height: "22px",
        width: "92px",
        // backgroundColor: tokens.token_black,
        position: "absolute",
        top: 5,
        right: "calc(70% - 9px)",
        "&:hover, &.Mui-focusVisible": {
            zIndex: 99,
            "& .MuiImageBackdrop-root": {
                opacity: 0.15
            }
        },
        transition: theme.transitions.create("opacity")
    };
});
var NameTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".85rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left"
    };
});
var DataTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var DefTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".75rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        textAlign: "left"
    };
});
var IndexTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var CVVICard = (0,styled/* default */.Z)(Card/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: "transparent",
        borderRadius: "12px",
        width: "375px",
        height: "225px",
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface,
        justifyContent: "center",
        alignItems: "center"
    };
});
var ReactSpeedometer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1199), __webpack_require__.e(2429)]).then(__webpack_require__.bind(__webpack_require__, 22429));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22429)
            ];
        }
    },
    ssr: false
});
function AboutCryptoCVVIGauge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CVVICard, {
        variant: "outlined",
        sx: {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSpeedometer, {
            fluidWidth: "true",
            // width={380}
            // height={200}
            minValue: 0,
            maxValue: 100,
            value: 50,
            valueFormat: "d",
            // customSegmentStops={[0, 20, 40, 60, 80, 100]}
            needleColor: "#0A2B3B",
            needleHeightRatio: 0.8,
            //   segmentValueFormatter={segmentValueFormatter}
            segmentColors: [
                "#fff2e8",
                "#ffdabf",
                "#ffb987",
                "#ff9b54",
                "#FF7E24"
            ],
            color: "#5F6368",
            valueTextFontSize: "0.85rem",
            currentValueText: "Crypto Vice and Virtue Index™: ${value}",
            // paddingHorizontal={34}
            // paddingVertical={34}
            customSegmentLabels: [
                {
                    text: "Virtue",
                    position: "INSIDE",
                    color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                    fontSize: "10px"
                },
                {
                    text: "Benevolence",
                    position: "INSIDE",
                    color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                    fontSize: "10px"
                },
                {
                    text: "Balance",
                    position: "INSIDE",
                    color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                    fontSize: "10px"
                },
                {
                    text: "Malice",
                    position: "INSIDE",
                    color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                    fontSize: "10px"
                },
                {
                    text: "Vice",
                    position: "INSIDE",
                    color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                    fontSize: "10px"
                }, 
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(50522);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
;// CONCATENATED MODULE: ./src/components/about/viceandvirtue/AboutCryptoCVVIDesc.js
/* eslint-disable no-unused-expressions */ /* eslint-disable no-template-curly-in-string */ /* eslint-disable no-unused-vars */ 








var CVVIButton = (0,styled/* default */.Z)(ButtonBase/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        height: 200
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        width: "100% !important",
        height: 100
    }), (0,_define_property/* default */.Z)(_obj, "&:hover, &.Mui-focusVisible", {
        zIndex: 99,
        "& .MuiImageBackdrop-root": {
            opacity: 0.15,
            backgroundColor: src_tokens/* tokens.token_apple_grey */.T.token_apple_grey
        },
        "& .MuiImageMarked-root": {
            opacity: 0
        },
        "& .MuiTypography-root": {
            border: "4px solid currentColor"
        }
    }), _obj;
});
var CVVIBackdrop = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface,
        opacity: 0,
        transition: theme.transitions.create("opacity")
    };
});
var AboutCryptoCVVIDesc_LogoMarked = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        height: "22px",
        width: "92px",
        // backgroundColor: tokens.token_black,
        position: "absolute",
        top: 5,
        right: "calc(70% - 9px)",
        "&:hover, &.Mui-focusVisible": {
            zIndex: 99,
            "& .MuiImageBackdrop-root": {
                opacity: 0.15
            }
        },
        transition: theme.transitions.create("opacity")
    };
});
var AboutCryptoCVVIDesc_NameTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".85rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left"
    };
});
var AboutCryptoCVVIDesc_DataTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var AboutCryptoCVVIDesc_DefTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".75rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        textAlign: "left"
    };
});
var AboutCryptoCVVIDesc_IndexTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.palette_primary */.T.palette_primary
    };
});
var DescCard = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: "transparent",
        borderRadius: "12px",
        maxWidth: "425px",
        height: "225px",
        paddingRight: "16px",
        paddingLeft: "16px",
        paddingTop: "16px",
        paddingBottom: "4px",
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
// const ReactSpeedometer = dynamic(() => import('react-d3-speedometer'), {
//   ssr: false,
// });
function AboutCryptoCVVIDesc() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescCard, {
        sx: {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc_NameTypo, {
                                children: "1 week ago"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc_DataTypo, {
                                children: "Balance"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: {
                            bgcolor: "#ffb987",
                            width: 28,
                            height: 28
                        },
                        "aria-label": "CVVI Value",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc_IndexTypo, {
                            children: "55"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: "5px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc_NameTypo, {
                                children: "1 month ago"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc_DataTypo, {
                                children: "Vice"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: {
                            bgcolor: src_tokens/* tokens.palette_secondary */.T.palette_secondary,
                            width: 28,
                            height: 28
                        },
                        "aria-label": "CVVI Value",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc_IndexTypo, {
                            children: "87"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: "5px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutCryptoCVVIDesc_DefTypo, {
                children: [
                    "blockquiry's Crypto Vice and Virtue Index™ is used to gauge the trust of the crypto community in the overall viability, safety, and security of the crypto ecosystem.",
                    " "
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/searchresults/cvvi/exchanges/ExchangeCVVI.js
/* eslint-disable no-template-curly-in-string */ /* eslint-disable no-unused-vars */ 







var ExchangeCVVI_CVVIButton = (0,styled/* default */.Z)(ButtonBase/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        height: 200
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        width: "100% !important",
        height: 185
    }), (0,_define_property/* default */.Z)(_obj, "&:hover, &.Mui-focusVisible", {
        zIndex: 99,
        "& .MuiImageBackdrop-root": {
            opacity: 0.15,
            backgroundColor: src_tokens/* tokens.token_apple_grey */.T.token_apple_grey
        },
        "& .MuiImageMarked-root": {
            opacity: 0
        },
        "& .MuiTypography-root": {
            border: "4px solid currentColor"
        }
    }), _obj;
});
var ExchangeCVVI_CVVIBackdrop = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface,
        opacity: 0,
        transition: theme.transitions.create("opacity")
    };
});
var ExchangeCVVI_LogoMarked = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        height: "26px",
        width: "26px",
        // backgroundColor: tokens.token_black,
        position: "absolute",
        top: 5,
        right: "calc(92% - 9px)"
    };
});
var ExchangeCVVI_NameTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".85rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left"
    };
});
var ExchangeCVVI_DataTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var ExchangeCVVI_DefTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".75rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        textAlign: "left"
    };
});
var ExchangeCVVI_IndexTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var ExchangeCVVI_CVVICard = (0,styled/* default */.Z)(Card/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_hairline */.T.token_hairline,
        borderRadius: "12px",
        width: "300px",
        height: "185px",
        margin: 2,
        display: "flex",
        flexWrap: "wrap",
        // paddingRight: '16px',
        // paddingLeft: '16px',
        // paddingTop: '4px',
        // paddingBottom: '4px',
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
var DefCard = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_hairline */.T.token_hairline,
        borderRadius: "12px",
        width: "330px",
        height: "185px",
        margin: 2,
        paddingRight: "16px",
        paddingLeft: "16px",
        paddingTop: "16px",
        paddingBottom: "4px",
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
var ExchangeCVVI_ReactSpeedometer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1199), __webpack_require__.e(2429)]).then(__webpack_require__.bind(__webpack_require__, 22429));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22429)
            ];
        }
    },
    ssr: false
});
function ExchangeCVVI(param) {
    var setSelectedInnerCvvi = param.setSelectedInnerCvvi;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        spacing: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCVVI_CVVICard, {
            variant: "outlined",
            sx: {},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExchangeCVVI_CVVIButton, {
                onClick: function() {
                    setSelectedInnerCvvi("Centralized Exchanges");
                },
                focusRipple: true,
                style: {
                    width: 300
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCVVI_CVVIBackdrop, {
                        className: "MuiImageBackdrop-root"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCVVI_ReactSpeedometer, {
                        fluidWidth: true,
                        // width={300}
                        // height={185}
                        minValue: 0,
                        maxValue: 100,
                        value: 67,
                        valueFormat: "d",
                        // customSegmentStops={[0, 20, 40, 60, 80, 100]}
                        needleColor: "0A2B3B",
                        needleHeightRatio: 0.6,
                        //   segmentValueFormatter={segmentValueFormatter}
                        segmentColors: [
                            "#fff2e8",
                            "#ffdabf",
                            "#ffb987",
                            "#ff9b54",
                            "#FF7E24", 
                        ],
                        color: "#5F6368",
                        valueTextFontSize: "0.75rem",
                        currentValueText: "Crypto CEX Vice and Virtue Index™: ${value}",
                        // paddingHorizontal={34}
                        // paddingVertical={34}
                        customSegmentLabels: [
                            {
                                text: "Virtue",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Benevolence",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Balance",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Malice",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Vice",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCVVI_LogoMarked, {
                        className: "MuiImageMarked-root",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 24,
                            height: 24,
                            src: "/cryptobank64x64_2.png",
                            alt: "logo"
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/searchresults/cvvi/dex/DexCVVI.js
/* eslint-disable no-template-curly-in-string */ /* eslint-disable no-unused-vars */ 







var DexCVVI_CVVIButton = (0,styled/* default */.Z)(ButtonBase/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        height: 200
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        width: "100% !important",
        height: 185
    }), (0,_define_property/* default */.Z)(_obj, "&:hover, &.Mui-focusVisible", {
        zIndex: 99,
        "& .MuiImageBackdrop-root": {
            opacity: 0.15,
            backgroundColor: src_tokens/* tokens.token_apple_grey */.T.token_apple_grey
        },
        "& .MuiImageMarked-root": {
            opacity: 0
        },
        "& .MuiTypography-root": {
            border: "4px solid currentColor"
        }
    }), _obj;
});
var DexCVVI_CVVIBackdrop = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface,
        opacity: 0,
        transition: theme.transitions.create("opacity")
    };
});
var DexCVVI_LogoMarked = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        height: "26px",
        width: "26px",
        // backgroundColor: tokens.token_black,
        position: "absolute",
        top: 5,
        right: "calc(92% - 9px)",
        transition: theme.transitions.create("opacity")
    };
});
var DexCVVI_NameTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".85rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left"
    };
});
var DexCVVI_DataTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var DexCVVI_DefTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".75rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        textAlign: "left"
    };
});
var DexCVVI_IndexTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var DexCVVI_CVVICard = (0,styled/* default */.Z)(Card/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_hairline */.T.token_hairline,
        borderRadius: "12px",
        width: "300px",
        height: "185px",
        margin: 2,
        display: "flex",
        flexWrap: "wrap",
        // paddingRight: '16px',
        // paddingLeft: '16px',
        // paddingTop: '4px',
        // paddingBottom: '4px',
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
var DexCVVI_DefCard = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_hairline */.T.token_hairline,
        borderRadius: "12px",
        width: "330px",
        height: "185px",
        margin: 2,
        paddingRight: "16px",
        paddingLeft: "16px",
        paddingTop: "16px",
        paddingBottom: "4px",
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
var DexCVVI_ReactSpeedometer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1199), __webpack_require__.e(2429)]).then(__webpack_require__.bind(__webpack_require__, 22429));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22429)
            ];
        }
    },
    ssr: false
});
function DexCVVI(param) {
    var setSelectedInnerCvvi = param.setSelectedInnerCvvi;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        spacing: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DexCVVI_CVVICard, {
            variant: "outlined",
            sx: {},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DexCVVI_CVVIButton, {
                focusRipple: true,
                onClick: function() {
                    return setSelectedInnerCvvi("Decentralized Exchanges");
                },
                style: {
                    width: 300
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DexCVVI_CVVIBackdrop, {
                        className: "MuiImageBackdrop-root"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DexCVVI_ReactSpeedometer, {
                        width: 300,
                        height: 185,
                        minValue: 0,
                        maxValue: 100,
                        value: 42,
                        valueFormat: "d",
                        // customSegmentStops={[0, 20, 40, 60, 80, 100]}
                        needleColor: "0A2B3B",
                        needleHeightRatio: 0.6,
                        //   segmentValueFormatter={segmentValueFormatter}
                        segmentColors: [
                            "#fff2e8",
                            "#ffdabf",
                            "#ffb987",
                            "#ff9b54",
                            "#FF7E24", 
                        ],
                        color: "#5F6368",
                        valueTextFontSize: "0.75rem",
                        currentValueText: "Crypto DAX Vice and Virtue Index™: ${value}",
                        // paddingHorizontal={34}
                        // paddingVertical={34}
                        customSegmentLabels: [
                            {
                                text: "Virtue",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Benevolence",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Balance",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Malice",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Vice",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DexCVVI_LogoMarked, {
                        className: "MuiImageMarked-root",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 24,
                            height: 24,
                            src: "/cryptocurrencyexchange98x98.png",
                            alt: "logo"
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/searchresults/cvvi/protocol/ProtocolCVVI.js
/* eslint-disable no-template-curly-in-string */ /* eslint-disable no-unused-vars */ 







var ProtocolCVVI_CVVIButton = (0,styled/* default */.Z)(ButtonBase/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        height: 200
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        width: "100% !important",
        height: 185
    }), (0,_define_property/* default */.Z)(_obj, "&:hover, &.Mui-focusVisible", {
        zIndex: 99,
        "& .MuiImageBackdrop-root": {
            opacity: 0.15,
            backgroundColor: src_tokens/* tokens.token_apple_grey */.T.token_apple_grey
        },
        "& .MuiImageMarked-root": {
            opacity: 0
        },
        "& .MuiTypography-root": {
            border: "4px solid currentColor"
        }
    }), _obj;
});
var ProtocolCVVI_CVVIBackdrop = (0,styled/* default */.Z)("span")(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface,
        opacity: 0,
        transition: theme.transitions.create("opacity")
    };
});
var ProtocolCVVI_LogoMarked = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        height: "26px",
        width: "26px",
        // backgroundColor: tokens.token_black,
        position: "absolute",
        top: 5,
        right: "calc(92% - 9px)"
    };
});
var ProtocolCVVI_NameTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".85rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left"
    };
});
var ProtocolCVVI_DataTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var ProtocolCVVI_DefTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: ".75rem",
        fontWeight: 400,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        // whiteSpace: 'nowrap',
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        textAlign: "left"
    };
});
var ProtocolCVVI_IndexTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Google Sans, Roboto, Arial, sans-serif",
        fontSize: "0.85rem",
        fontWeight: 500,
        lineHeight: "1.00rem",
        letterSpacing: ".025em",
        textAlign: "left",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized
    };
});
var ProtocolCVVI_CVVICard = (0,styled/* default */.Z)(Card/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_hairline */.T.token_hairline,
        borderRadius: "12px",
        width: "300px",
        height: "185px",
        margin: 2,
        display: "flex",
        flexWrap: "wrap",
        // paddingRight: '16px',
        // paddingLeft: '16px',
        // paddingTop: '4px',
        // paddingBottom: '4px',
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
var ProtocolCVVI_DefCard = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_hairline */.T.token_hairline,
        borderRadius: "12px",
        width: "330px",
        height: "185px",
        margin: 2,
        paddingRight: "16px",
        paddingLeft: "16px",
        paddingTop: "16px",
        paddingBottom: "4px",
        backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
    };
});
var ProtocolCVVI_ReactSpeedometer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1199), __webpack_require__.e(2429)]).then(__webpack_require__.bind(__webpack_require__, 22429));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22429)
            ];
        }
    },
    ssr: false
});
function ProtocolCVVI(param) {
    var setSelectedInnerCvvi = param.setSelectedInnerCvvi;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        spacing: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCVVI_CVVICard, {
            variant: "outlined",
            sx: {},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProtocolCVVI_CVVIButton, {
                focusRipple: true,
                onClick: function() {
                    return setSelectedInnerCvvi("Blockchains");
                },
                style: {
                    width: 300
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCVVI_CVVIBackdrop, {
                        className: "MuiImageBackdrop-root"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCVVI_ReactSpeedometer, {
                        fluidWidth: true,
                        // width={300}
                        // height={185}
                        minValue: 0,
                        maxValue: 100,
                        value: 40,
                        valueFormat: "d",
                        // customSegmentStops={[0, 20, 40, 60, 80, 100]}
                        needleColor: "1a5371",
                        needleHeightRatio: 0.6,
                        //   segmentValueFormatter={segmentValueFormatter}
                        segmentColors: [
                            "#fff2e8",
                            "#ffdabf",
                            "#ffb987",
                            "#ff9b54",
                            "#FF7E24", 
                        ],
                        color: "#5F6368",
                        valueTextFontSize: "0.85rem",
                        currentValueText: "Blockchain Vice and Virtue Index™: ${value}",
                        // paddingHorizontal={34}
                        // paddingVertical={34}
                        customSegmentLabels: [
                            {
                                text: "Virtue",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Benevolence",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Balance",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Malice",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            },
                            {
                                text: "Vice",
                                position: "INSIDE",
                                color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                                fontSize: "10px"
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCVVI_LogoMarked, {
                        className: "MuiImageMarked-root",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 24,
                            height: 24,
                            src: "/blockchain67x67.png",
                            alt: "logo"
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/about/viceandvirtue/ViceAndVirtueMain.js
/* eslint-disable no-unused-vars */ 











var Item = (0,styled/* default */.Z)(Paper/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        // ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "left",
        borderColor: "transparent"
    };
});
var IntroTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        color: src_tokens/* tokens.token_black */.T.token_black,
        fontFamily: "Roboto, Arial,  sans-serif",
        fontWeight: 400,
        fontSize: "1.75rem",
        letterSpacing: -0.5,
        lineHeight: "2.125rem",
        paddingTop: "24px",
        textAlign: "center",
        opacity: 1
    };
});
var BlockTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "play",
        opacity: 1,
        fontSize: "1.00rem",
        fontWeight: 700,
        lineHeight: "1.25rem",
        textAlign: "center",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: src_tokens/* tokens.palette_primary */.T.palette_primary
    };
});
var ViceAndVirtueMain_IndexTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        opacity: 1,
        fontSize: "1.5rem",
        fontWeight: 500,
        lineHeight: "1.75rem",
        textAlign: "left",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: src_tokens/* tokens.token_typography_headline */.T.token_typography_headline
    };
});
function ColorText(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("span", {
        style: {
            color: tokens.palette_secondary
        },
        children: children
    });
}
var SectionTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        opacity: 1,
        fontSize: "1.25rem",
        fontWeight: 500,
        lineHeight: "1.50rem",
        textAlign: "left",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: src_tokens/* tokens.token_black */.T.token_black
    };
});
var RegTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        opacity: 1,
        display: "inline-block",
        fontSize: "1.00rem",
        fontWeight: 400,
        fontStyle: "normal",
        lineHeight: "1.25rem",
        letterSpacing: "normal",
        // textAlign: 'left',
        color: src_tokens/* tokens.token_grey_700 */.T.token_grey_700
    };
});
function ViceAndVirtuMain() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                maxWidth: "925px",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "240px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid2/* default */.Z, {
                container: true,
                spacing: 0.5,
                flexDirection: {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            variant: "outlined",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroTypo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 12,
                        sx: {
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            variant: "outlined",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViceAndVirtueMain_IndexTypo, {
                                        children: "Crypto Vice and Virtue Index™"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    children: "What is driving crypto economy now?"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 6,
                        sx: {
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            width: "auto",
                            paddingRight: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIGauge, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 6,
                        sx: {
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            width: "auto",
                            paddingLeft: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCryptoCVVIDesc, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 12,
                        // md={6}
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            variant: "outlined",
                            sx: {
                                marginTop: "4px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegTypo, {
                                children: [
                                    "Crypto Vice and Virtue Index™ breaks down further into layers of: Crypto ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "Exchanges"
                                    }),
                                    " Vice and Virtue Index™, Crypto",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "DEX"
                                    }),
                                    " Vice and Virtue Index™, and Crypto ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "Blockchain"
                                    }),
                                    " ",
                                    "Vice and Virtue Index™. The index breakdown aims to allow users to understand the viability, security and safety differences between the protocol/technology layer vs. the decentralized application layer vs. the centralized application layer.",
                                    " "
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 12,
                        // md={6}
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            variant: "outlined",
                            sx: {
                                marginBottom: "4px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                children: "Within each layer top five entities, projects and protocols by bitcoin and ethereum transaction volume are assigned their individual index."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 4,
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "300px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeCVVI, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 4,
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: "300px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DexCVVI, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 4,
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: "300px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCVVI, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                        xs: 12,
                        sx: {
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTypo, {
                                    sx: {
                                        marginTop: "20px",
                                        marginBottom: "10px"
                                    },
                                    children: "Vice and Virtue FAQs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    sx: {
                                        marginBottom: "8px",
                                        marginTop: "16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "What is the Crypto Vice and Virtue Index™?"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    children: "The Crypto Vice and Virtue Index™ is a way to gauge the trust of the crypto community in the overall viability, safety, and security of the crypto ecosystem."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    sx: {
                                        marginBottom: "8px",
                                        marginTop: "16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "How is Crypto Vice and Virtue Index™ Calculated?"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    children: "The Crypto Vice and Virtue Index™ is a compilation of seven indicators measuring various aspects of participants' sentiment and blockchain activity. The index tracks how much these individual indicators deviate from their averages compared to how much they normally diverge. The index gives each indicator equal weighting in calculating a score from 0 to 100, with 100 representing maximum virtue and 0 signaling maximum vices."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    sx: {
                                        marginBottom: "8px",
                                        marginTop: "16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "Which indicators make up the Crypto Vice and Virtue Index™?"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    children: "Indicators that make up the Crypto Vice and Virtue Index™ include: Twitter sentiment, Reddit sentiment, general news sentiment, Crypto Panic news sentiment, Chainabuse reporting blockquiry reporting and overall transaction volume for bitcoin and ethereum."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    sx: {
                                        marginBottom: "8px",
                                        marginTop: "16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "How often is Crypto Vice and Virtue Index™ Calculated?"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegTypo, {
                                    children: "Every component and the Index are calculated as soon as new data becomes available."
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var ViceAndVirtueMain = (ViceAndVirtuMain);

;// CONCATENATED MODULE: ./pages/about/blockquiry/viceandvirtueindex.js






function ViceAndVirtueIndex() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Vice and Virtue Index™ - About Vice and Virtue Index - About blockquiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "blockquiry's Crypto Vice & Virtue Index is used to gauge the trust of the crypto community in the overall viability, safety, and security of the crypto ecosystem. Crypto Vice & Virtue Index breaks down further into Crypto Exchanges Vice and Virtue Index, Crypto DEX Vice and Virtue Index, and Crypto Protocol Vice and Virtue Index. "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: "blockquiry's Crypto Vice & Virtue Index is a way to gauge blockchain security and safety and whether users' sentiment corresponds to actual blockchain performance."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                disableGutters: true,
                maxWidth: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViceAndVirtueMain, {})
            })
        ]
    });
}
ViceAndVirtueIndex.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutLayout/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var viceandvirtueindex = (ViceAndVirtueIndex);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1086,2013,3517,4540,3835,1816,5426,877,517,2390,3408,9073,8346,247,7575,8653,2397,1872,4215,5675,170,5873,2381,3379,9774,2888,179], function() { return __webpack_exec__(62609); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);